export default "__VITE_ASSET__DHf5N4nm__"